// extracted by mini-css-extract-plugin
export default {"container":"InteractionSummaryGI_container__6pLif"};